const getters = {
	permissions: state => state.user.permissions,
	token: state => state.user.token,
	returnUrl: state => state.user.returnUrl,
}
export default getters
